module.exports = __webpack_public_path__ + "img/icon 2@3x.82095f6e.png";